(function () {
  "use strict";

  var blocks = document.querySelectorAll("[data-countdown]");
  if (!blocks.length) return;

  function pad(n) {
    return String(Math.max(0, n)).padStart(2, "0");
  }

  function tick(el) {
    var target = new Date(el.getAttribute("data-target").replace(" ", "T"));
    if (isNaN(target.getTime())) return;

    var hideWhenEnded = el.getAttribute("data-hide-when-ended") === "true";
    var daysEl = el.querySelector("[data-countdown-days]");
    var hoursEl = el.querySelector("[data-countdown-hours]");
    var minutesEl = el.querySelector("[data-countdown-minutes]");
    var secondsEl = el.querySelector("[data-countdown-seconds]");

    function update() {
      var diff = target.getTime() - Date.now();
      if (diff <= 0) {
        if (daysEl) daysEl.textContent = "00";
        if (hoursEl) hoursEl.textContent = "00";
        if (minutesEl) minutesEl.textContent = "00";
        if (secondsEl) secondsEl.textContent = "00";
        if (hideWhenEnded) el.style.display = "none";
        clearInterval(interval);
        return;
      }
      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    update();
    var interval = setInterval(update, 1000);
  }

  blocks.forEach(tick);
})();
